// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9b944272","952":"c64f3381"}[chunkId] + ".chunk.js";
};